export const serviceData = [
    {
        id: "1",
        title: "Repair",
        rating: "4.7",
        bookings: "2k+",
        points: [
            "Price include visit & diagnosis charges",
            "Spare part rate applicable as per rate card",
        ],
        image: "/img/location/data-REPIR.avif",
        price: 399,
        oldPrice: 450,
    },

    {
        id: "518",
        title: "Service",
        rating: "4.7",
        bookings: "3k+",
        points: [
            "Thorough inspection and repair of your RO for issues like leakage, less water flow, dirty/smelly water etc.",
            "Cleaning of Machine and Filters",
        ],
        image: "/img/location/data-ROUTINE-SERVICE.avif",
        price: 399,
        oldPrice: 450,
    },

    {
        id: "2",
        title: "Installation",
        rating: "4.7",
        bookings: "3k+",
        points: [
            "Include Fixing of water purifier stand on wall",
            "Connect inlet water assembly to water purifier",
        ],
        image: "/img/location/data-RO-INSTALLATION.avif",
        price: 499,
        oldPrice: 700,
    },

    {
        id: "3",
        title: "Un-installation",
        rating: "4.7",
        bookings: "4k+",
        points: [
            "Dismantle of water purifier from the wall",
            "Dismantle of inlet water assembly from water purifier",
        ],
        image: "/img/location/data-RO-UNINSTALLATION.avif",
        price: 399,
        oldPrice: 499,
    },

    {
        id: "103",
        title: "AMC Plan 1",
        rating: "4.3",
        bookings: "6k+",
        points: [
            "Three periodical services",
            "Any addition visit by intimation",
        ],
        image: "/img/location/data-AMC.avif",
        price: 999,
        oldPrice: 1200,
    },

    {
        id: "104",
        title: "AMC Plan 2",
        rating: "4.3",
        bookings: "7k+",
        points: [
            "Three periodical services",
            "Any addition visit by intimation",
        ],
        image: "/img/location/data-AMC.avif",
        price: 2500,
        oldPrice: 3000,
    },

    {
        id: "106",
        title: "AMC Plan 3",
        rating: "4.3",
        bookings: "2k+",
        points: [
            "Three periodical services",
            "Any addition visit by intimation",
        ],
        image: "/img/location/data-AMC.avif",
        price: 2600,
        oldPrice: 3000,
    },

    {
        id: "105",
        title: "AMC Plan 4",
        rating: "4.3",
        bookings: "1k+",
        points: [
            "Three periodical services",
            "Any addition visit by intimation",
        ],
        image: "/img/location/data-AMC.avif",
        price: 3999,
        oldPrice: 4500,
    },

    {
        id: "107",
        title: "AMC Plan 5 (CAMC)",
        rating: "4.4",
        bookings: "3k+",
        points: [
            "Three periodic services",
            "Additional visits with prior intimation",
        ],
        image: "/img/location/data-AMC.avif",
        price: 4999,
        oldPrice: 5500,
    },

    {
        id: "108",
        title: "AMC Plan 6 (CAMC)",
        rating: "4.4",
        bookings: "4k+",
        points: [
            "Three periodic services",
            "Additional visits with prior intimation",
        ],
        image: "/img/location/data-AMC.avif",
        price: 5999,
        oldPrice: 6500,
    },
];